module.exports = __webpack_public_path__ + "img/padlock-unlocked.66ac57b9.svg";